import {
    AutocompleteInput,
    DateInput,
    ReferenceInput,
    NumberInput,
    TextInput,
    required,
} from 'react-admin';
import { SimpleForm } from '@components/SimpleForm';
import { Grid } from '@mui/material';
import { format } from '@helpers/numeric.ext';

export const OrderDetailForm = () => {
    return (
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <DateInput source="order.createdAt" />
                </Grid>
                <Grid item xs={12} md={3}>
                    <ReferenceInput
                        source="orderId"
                        reference="order"
                        perPage={20}
                    >
                        <AutocompleteInput
                            optionText="invoiceNo"
                            validate={[required()]}
                        />
                    </ReferenceInput>
                </Grid>
                <Grid item xs={12} md={3}>
                    <ReferenceInput
                        source="storeId"
                        reference="store"
                        perPage={20}
                    >
                        <AutocompleteInput
                            optionText="name"
                            validate={[required()]}
                        />
                    </ReferenceInput>
                </Grid>
                <Grid item xs={12} md={3}>
                    <ReferenceInput
                        source="createdBy"
                        reference="users"
                        perPage={20}
                    >
                        <AutocompleteInput
                            optionText="name"
                            validate={[required()]}
                        />
                    </ReferenceInput>
                </Grid>
                <Grid item xs={12} md={6}>
                    <ReferenceInput
                        source="goodsId"
                        reference="goods"
                        perPage={20}
                    >
                        <AutocompleteInput
                            optionText="name"
                            validate={[required()]}
                        />
                    </ReferenceInput>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput source="description" multiline />
                </Grid>
                <Grid item xs={12} md={3}>
                    <NumberInput
                        source="quantity"
                        validate={[required()]}
                        format={format}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <NumberInput
                        source="sellingPrice"
                        validate={[required()]}
                        format={format}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <NumberInput
                        source="purchasePrice"
                        validate={[required()]}
                        format={format}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <NumberInput
                        source="amount"
                        validate={[required()]}
                        format={format}
                    />
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
